import type { Appointment, AppointmentDraft } from 'services/types/appointment';

import baseApi from './baseApi';

const appointmentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAppointments: build.query<Appointment[], { businessUnitId: number; month: string }>({
      query: ({ businessUnitId, month }) => ({
        url: `/appointments?businessUnitId=${businessUnitId}&month=${month}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { businessUnitId, month }) => [
        { type: 'Appointments', id: `${businessUnitId}-${month}` },
        { type: 'Appointments', id: 'LIST' },
      ],
    }),
    createAppointment: build.mutation<Appointment, AppointmentDraft>({
      query: (body) => ({
        url: '/appointments',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Appointments', id: 'LIST' }],
    }),
    updateAppointment: build.mutation<Appointment, { id: number; changes: Partial<AppointmentDraft> }>({
      query: ({ id, changes }) => ({
        url: `/appointments/${id}`,
        method: 'PATCH',
        body: changes,
      }),
      invalidatesTags: [{ type: 'Appointments', id: 'LIST' }],
    }),
    deleteAppointment: build.mutation<void, number>({
      query: (id) => ({
        url: `/appointments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Appointments', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAppointmentsQuery,
  useCreateAppointmentMutation,
  useUpdateAppointmentMutation,
  useDeleteAppointmentMutation,
} = appointmentsApi;
